import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled, { css } from "styled-components";

import chevronLeft from "assets/icons/chevron_left-blue.svg";
import chevronRight from "assets/icons/chevron_right-blue.svg";
import { RootState } from "redux/reducers";
import { setCustomSearchPosition } from "redux/actions/custom-report";

type ButtonProps = { readonly disabled: boolean };

const CustomReportNavigator: React.FC = () => {
  const dispatch = useDispatch();
  const { customReport } = useSelector((state: RootState) => state);
  const [position, setPosition] = useState<number>(
    customReport.search["position"]
  );
  const headerHeight = document.getElementById("ReportHeader")?.offsetHeight;

  let distFromTop = 100;
  if (headerHeight) distFromTop = headerHeight + 150;

  useEffect(() => {
    setPosition(customReport.search["position"]);
  }, [customReport.search]);

  useEffect(() => {
    setPosition(1);
    dispatch(setCustomSearchPosition(1));
  }, [customReport.currentChapter, dispatch]);

  useEffect(() => {
    window.scrollTo(
      0,
      customReport.search.scrollPositions[position - 1] - distFromTop
    );
  }, [distFromTop, position, customReport.search.scrollPositions, dispatch]);

  const prevPosition = () => {
    setPosition(position - 1);
    window.scrollTo(
      0,
      customReport.search.scrollPositions[position - 1] - distFromTop
    );
    dispatch(setCustomSearchPosition(position - 1));
  };

  const nextPosition = () => {
    setPosition(position + 1);
    window.scrollTo(
      0,
      customReport.search.scrollPositions[position + 1] - distFromTop
    );
    dispatch(setCustomSearchPosition(position + 1));
  };

  return (
    <Container>
      <NavigationButton
        disabled={position === 1}
        onClick={() => prevPosition()}
      >
        <img src={chevronLeft} alt="left arrow icon" />
      </NavigationButton>
      <NavInfo>
        <p>
          {position} of {customReport.search.scrollPositions.length}
        </p>
      </NavInfo>
      <NavigationButton
        disabled={position + 1 > customReport.search.scrollPositions.length}
        onClick={() => nextPosition()}
      >
        <img src={chevronRight} alt="right arrow icon" />
      </NavigationButton>
    </Container>
  );
};

const Container = styled.div`
  background-color: ${(props) => props.theme.colors.lighterGrey};
  border: 1px solid ${(props) => props.theme.colors.idataBlue};
  border-radius: 10rem;
  color: ${(props) => props.theme.colors.idataBlue};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const NavInfo = styled.div`
  font-size: 2.2rem;
  text-align: center;

  p {
    margin: 0;
  }
`;

const disabledStyles = css`
  opacity: 0.4;
  pointer-events: none;
`;

const NavigationButton = styled.button<ButtonProps>`
  background: transparent;
  border: none;
  padding: 0;

  &:hover {
    opacity: 0.8;
  }

  ${(props) => (props.disabled ? disabledStyles : null)}
`;

export default CustomReportNavigator;
